import axios from 'axios';

const headers = (csrfToken) => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-CSRF-Token': csrfToken,
});

export const fetchVenueAgeRestrictions = (teamId, venueOwnershipId, csrfToken) =>
  axios.get(
    `/teams/${teamId}/venue_ownerships/${venueOwnershipId}/age_restrictions`,
    { headers: headers(csrfToken) }
  ).then((res) => res.data);

export const updateVenueAgeRestrictions = (teamId, venueOwnershipId, payload, csrfToken) =>
  axios.patch(
    `/teams/${teamId}/venue_ownerships/${venueOwnershipId}/age_restrictions`,
    payload,
    { headers: headers(csrfToken) }
  );
